import * as stylex from '@stylexjs/stylex'

export const system = stylex.defineVars({
  unit: '4px',
  columns: stylex.types.number(16),
})

export type System = typeof system
